import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import da from './locales/da.json'
import en from './locales/en.json'
import { detectLocaleFromPath } from '../helpers/locale'

// The URL is the source of truth for the language (/en prefix). Initializing
// from it makes the first paint match the URL instead of flashing the
// browser's preferred language until LocaleSync corrects it.
i18n.use(initReactI18next).init({
  resources: {
    da: { translation: da },
    en: { translation: en },
  },
  lng: detectLocaleFromPath(window.location.pathname),
  fallbackLng: 'en',
  interpolation: {
    // React already escapes rendered strings
    escapeValue: false,
  },
})

export default i18n
